import { cn } from '@/lib/cn';

export type Status = 'PASS' | 'WARN' | 'FAIL' | 'RUNNING';

const STYLES: Record<Status, string> = {
  PASS: 'bg-success/12 text-success ring-success/25',
  WARN: 'bg-warning/15 text-warning ring-warning/30',
  FAIL: 'bg-destructive/12 text-destructive ring-destructive/25',
  RUNNING: 'bg-muted text-muted-foreground ring-border',
};

const LABELS: Record<Status, string> = {
  PASS: 'OK',
  WARN: 'Atenção',
  FAIL: 'Falha',
  RUNNING: 'Verificando',
};

/**
 * Estado em cor **e** em palavra.
 *
 * Cor sozinha não comunica para daltônicos, e num painel de diagnóstico o
 * estado é a informação principal.
 */
export function StatusPill({ status, className }: { status: Status; className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold ring-1 ring-inset',
        STYLES[status],
        className,
      )}
    >
      {LABELS[status]}
    </span>
  );
}
